import { Box, Container, Heading, Text } from '@chakra-ui/react'
import PageLayout from 'commons/components/layout/PageLayout'
import { PaymentSources } from 'commons/constants/paymentTypes'
import {
	BgColors,
	BorderRadius,
	BrandColors,
	Spacing,
	TextColors
} from 'commons/design-system/tokens'
import { SuccessPageFooter } from 'features/success-page/components/SuccessPageFooter'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const TinkSuccessPage = () => {
	const { t } = useTranslation()

	const isFromLydiaPage = useMemo(() => {
		const urlParams = new URLSearchParams(window.location.search)
		return urlParams.get('source') === PaymentSources.LYDIA_PAGE
	}, [])

	const titleKey = isFromLydiaPage
		? 'success.tink_lydia_page_success_title'
		: 'success.tink_success_title'
	const descriptionKey = isFromLydiaPage
		? 'success.tink_lydia_page_success_description'
		: 'success.tink_success_description'

	return (
		<PageLayout
			withConfetti
			alignItems='center'
			justifyContent='center'
			footer={<SuccessPageFooter />}
		>
			<Container
				maxW={'810px'}
				centerContent
				textAlign={'center'}
				px={Spacing.SM}
				mt={{ base: 10, md: 0 }}
			>
				<Box mt={4} bg={BgColors.Z5} p={Spacing['3XL']} borderRadius={BorderRadius.L}>
					<Heading
						fontFamily='Degular'
						fontWeight='bold'
						as='h1'
						fontSize='20px'
						color={BrandColors.PRIMARY}
						mb={Spacing.XL}
						maxW={'510px'}
					>
						{t(titleKey)}
					</Heading>
					<Text
						fontSize='16px'
						fontFamily={'Montserrat'}
						fontWeight={600}
						color={TextColors.TERTIARY}
						lineHeight={'24px'}
						maxW={'490px'}
					>
						{t(descriptionKey)}
					</Text>
				</Box>
			</Container>
		</PageLayout>
	)
}

export default TinkSuccessPage
